<mat-card>
  <mat-card-header>
    <mat-card-title-group>
    <mat-card-title>Quiz Questions</mat-card-title>
      <mat-card-subtitle>
        <button mat-raised-button color="primary" (click)="syncQuestions($event)">
          Sync Questions
        </button>
      </mat-card-subtitle>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="questions" multiTemplateDataRows>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let p">
          {{p.id}}
        </td>
      </ng-container>
      <ng-container matColumnDef="questionText">
        <th mat-header-cell *matHeaderCellDef>Question Text</th>
        <td mat-cell *matCellDef="let p">
          {{p.questionText}}
        </td>
      </ng-container>
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>Category</th>
        <td mat-cell *matCellDef="let p">
          {{p.category}}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let p" class="buttons">
          <button mat-raised-button color="primary" [disabled]="currentQuestion?.id == p.id" (click)="selectQuestion($event, p)">
            Select
          </button>
          <button mat-raised-button color="accent" (click)="clearResponses($event, p)">
            Clear Responses
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columns.length">
          <div class="example-element-detail" *ngIf="element.answers?.length" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div class="inner-table mat-elevation-z8" *ngIf="element == expandedElement">
              <table #innerTables mat-table [dataSource]="element.answers">
                <ng-container matColumnDef="{{innerColumn}}" *ngFor="let innerColumn of innerDisplayedColumns">
                  <th mat-header-cell *matHeaderCellDef> {{innerColumn}} </th>
                  <td mat-cell *matCellDef="let element"> {{element[innerColumn]}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns;" [class.correct-answer]='row.correct'></tr>
              </table>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let element; columns: columns;" [class.example-element-row]="element.answers?.length"
          [class.example-expanded-row]="expandedElement === element" [class.current-question]='currentQuestion?.id == element.id' (click)="toggleRow(element)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
  </mat-card-content>
</mat-card>
